import React, { Suspense, useEffect } from 'react'
import { Route, Routes as Switch, useNavigate } from "react-router-dom";
import Layout from './Layout/Layout';
import { RecoilRoot } from 'recoil';
import HeaderEmail from '../pages/HeaderEmail/HeaderEmail';
import HeaderEmailCreate from '../pages/HeaderEmail/HeaderEmailCreate';
import FooterEmail from '../pages/FooterEmail/FooterEmail';
import FooterEmailCreate from '../pages/FooterEmail/FooterEmailCreate';
import MyProfile from '../pages/MyProfile/MyProfile';
import TemplateEmail from '../pages/TemplateContent/TemplateEmail';
import TemplateEmailCreate from '../pages/TemplateContent/TemplateCreate';
import { Roles } from '../pages/roles/roles';
import { CreateRole } from '../pages/roles/createRole';
import { Users } from '../pages/users/users';
import { CreateUser } from '../pages/users/createUser';
import Report from '../pages/Report/Report';
import ErrorReport from '../pages/ErrorReport/errorReport';
import ErrorReportDetails from '../pages/ErrorReport/errorReportDetails';
import SentReport from '../pages/sentReport/sentReport';
import SentReportDetails from '../pages/sentReport/sentReportDetails';
import ReportDetails from '../pages/Report/ReportDetails';




const AdminLayout = () => {

    const navigate = useNavigate();

    useEffect(() => {
        const logged = localStorage.getItem('token');
        if (!logged) {
            navigate('/login')
        }
    }, [])

    return (
        <Suspense
            fallback={
                <div style={{ height: '100vh' }}>
                    Loading...
                </div>
            }
        >
            <RecoilRoot>
                <Layout>
                    <Switch>

                        {/* Header email */}
                        <Route path="/header-email" element={<HeaderEmail />} />
                        <Route path="/create-header" element={<HeaderEmailCreate />} />
                        <Route path="/edit-header/:id" element={<HeaderEmailCreate />} />
                        {/* Header email */}

                        {/* Footer email */}
                        <Route path="/footer-email" element={<FooterEmail />} />
                        <Route path="/create-footer" element={<FooterEmailCreate />} />
                        <Route path="/edit-footer/:id" element={<FooterEmailCreate />} />
                        {/* Footer email */}

                        {/* Template email */}
                        <Route path="/template-email" element={<TemplateEmail />} />
                        <Route path="/create-template" element={<TemplateEmailCreate />} />
                        <Route path="/edit-template/:id" element={<TemplateEmailCreate />} />
                        {/* Template email */}

                        {/* Roles */}
                        <Route path="/roles" element={<Roles />} />
                        <Route path="/create-role" element={<CreateRole />} />
                        <Route path="/edit-role/:id" element={<CreateRole />} />
                        {/* Roles */}

                        {/* Users */}
                        <Route path="/users" element={<Users />} />
                        <Route path="/create-user" element={<CreateUser />} />
                        <Route path="/edit-user/:id" element={<CreateUser />} />
                        {/* Users */}

                        <Route path="/my-profile" element={<MyProfile />} />

                        <Route path="/reports" element={<Report />} />
                        <Route path="/report-details" element={<ReportDetails />} />

                        {/* Error Report */}
                        <Route path="/error-report" element={<ErrorReport />} />
                        <Route path="/error-report-details" element={<ErrorReportDetails />} />
                        {/* Error Report */}

                        {/* Sent Report */}
                        <Route path="/sent-report" element={<SentReport />} />
                        <Route path="/sent-report-details" element={<SentReportDetails />} />
                        {/* Sent Report */}
                    </Switch>
                </Layout>
            </RecoilRoot>
        </Suspense>
    )
}

export default AdminLayout